/* eslint-disable func-names, no-param-reassign, react/destructuring-assignment */
import useMergedRef from '@react-hook/merged-ref';
import { DreamBlock } from '@typedream/core';
import {
  findNodePath,
  PlateRenderElementProps,
  TRenderElementProps,
} from '@udecode/plate-core';
import { ComponentType, useRef } from 'react';
import { Floating } from '../../../components/Floating';
import CollectionDataElementBlockTag from '../../../nodes/collection/components/CollectionDataElement/CollectionDataElementBlockTag';
import { OverlayPortal } from '../../../overlay/OverlayPortal';
import { DreamEditor } from '../../../types';
import { useDropBlock } from '../hooks/useDropBlock';
import { dropItemOnElement } from '../transforms';
import { DropLine } from './DropLine';

export const withDropTarget = (
  Component: ComponentType<TRenderElementProps<any, any>>,
) => (function DropTarget(props: PlateRenderElementProps) {
  const editor = props.editor as unknown as DreamEditor;
  const element = props.element as DreamBlock;

  const [{ isOver, canDrop, dropDirection }, dropTarget] = useDropBlock(
    element,
    {
      drop: (item, direction) => {
        const path = findNodePath(editor, element);
        if (path) {
          dropItemOnElement(editor, path, item, direction);
        }
      },
    },
  );

  const ref = useRef(null);
  const mergedRef = useMergedRef(ref, dropTarget, props.attributes.ref);

  return (
    <>

      <Component
        {...props}
        attributes={{
          ...props.attributes,
          ref: mergedRef,
        }}
      >
        {props.children}
        <CollectionDataElementBlockTag element={element} />
      </Component>

      {isOver && canDrop && (
        <OverlayPortal>
          <Floating
            reference={ref}
            cover
            autoUpdate
            style={{
              backgroundColor: 'var(--dropBackground)',
            }}
          >
            {dropDirection && <DropLine direction={dropDirection} />}
          </Floating>
        </OverlayPortal>
      )}
    </>
  );
});
